import domainsRegistry from "../data/permission-domains.json" with { type: "json" };
export const permissionDomains = domainsRegistry;
export const PermissionDomain = Object.keys(domainsRegistry).reduce((accumulator, domainCode) => {
    const key = domainCode.toUpperCase();
    accumulator[key] = domainCode;
    return accumulator;
}, {});
//# sourceMappingURL=domains.js.map